import { Loading } from '@lib/components'
import { Button } from '@octopus-do/octopus-storybook'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { artBoardActions } from '@store/reducers/artboard'
import { managerActions } from '@store/reducers/manager/actions'
import { activityHistoryActions } from '@store/reducers/manager/activityHistory/actions'
import {
  getActivityHistoryActions,
  getActivityHistoryTotal,
  isActionHistoryLoading,
} from '@store/reducers/manager/activityHistory/selectors'
import type React from 'react'
import { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useUnmount } from '@/hooks/useUnmount'
import type { ActivityHistoriesState, AppState } from '@/types'
import { AccordionItem } from './components'
import { getProjectCreateDate, groupedActions } from './helper'
import css from './styles.module.css'

export const ActivityHistory: React.FC = () => {
  const dispatch = useDispatch()

  const projectId = useSelector(migrationProjectSelector.getProjectId)

  const loading = useSelector(isActionHistoryLoading)
  const actions = useSelector(getActivityHistoryActions)
  const total = useSelector(getActivityHistoryTotal)

  useEffect(() => {
    dispatch(activityHistoryActions.fetchActionsSaga())
  }, [])

  const [activeAccordion, setActiveAccordion] = useState<
    Record<string, boolean>
  >({})

  const { dateFormat } = useSelector<AppState, any>(({ user }) => user)

  const createdAt = useSelector(migrationProjectSelector.getProjectCreatedAt)

  const grouped: ActivityHistoriesState[] = useMemo(
    () => groupedActions(actions),
    [actions]
  )

  useUnmount(() => {
    if (projectId) {
      dispatch(managerActions.fetchProjectSaga({ id: projectId }))
    }

    dispatch(artBoardActions.setActivityHistoryStatus({ status: false }))
  })

  const loadActions = () => {
    dispatch(activityHistoryActions.fetchActionsSaga())
  }

  if (loading && actions.length === 0) {
    return (
      <div className={css.loader}>
        <Loading type="medium" color="gray" />.
      </div>
    )
  }

  return (
    <div className={css.container}>
      {grouped.map((item: any) => (
        <AccordionItem
          key={item.id}
          {...item}
          activeAccordion={activeAccordion}
          onSetActiveAccordion={setActiveAccordion}
        />
      ))}

      {total > actions.length && (
        <div className={css.more}>
          <Button
            priority="secondary"
            size="medium"
            label="More"
            loading={loading}
            onClick={loadActions}
          />
        </div>
      )}

      <div className={css.divider} />

      <div className={css.project_created_info}>
        <div>Project created {getProjectCreateDate(createdAt, dateFormat)}</div>
      </div>
    </div>
  )
}
